export const environment = {
  production: true,
  eurogerm: false,
  hmr: false,
  apiUrl: "https://api.econnect.local/",
  webSocketURL: "wss://ws.econnect.local:4443/",
  webSocketLocalURL: 'wss://127.0.0.1:7681/',
  versionCheckURL: `https://${window.location.host}/version.json`,
  serverAuthUrl: "https://econnect-is-sts.endepro.net",
  defaultScope: "econnect-api",
  screenIP: "127.0.0.1:7681/",
};

